<div class="grid form-container">

  <!-- <div class="grid"> -->
  <div class="form-field col-12 md:col-12 lg:col-12 p-0">
    <div class="form-errors alert alert-danger" [hidden]='!forgotPasswordErrors[0]["general"]'>
      <div *ngFor="let ErrorMessage of forgotPasswordErrors['general']">
        {{ErrorMessage.message}}
      </div>
    </div>
    <!-- </div> -->

    <form [formGroup]='editforgotForm'>

      <div class="form-field col-12 md:col-12 lg:col-12">
        <div class="form-label col-12 md:col-12 lg:col-12 pb-3 pl-0 pr-0">
          <label for="otpInput" style="white-space: break-spaces;" translate>label_otp_msg</label>
        </div>
        <div class="form-label">
          <label for="username" translate>Username</label>
        </div>
        <div class="form-control">
          <input formControlName="username" type="text" pInputText />
        </div>
        <div class="form-errors" *ngIf="editforgotForm.controls.username.errors  && (editforgotForm.controls.username.dirty || editforgotForm.controls.username.touched)">
          <div [hidden]="!editforgotForm.controls.username.errors.required" translate>
            email_required
          </div>
          <div [hidden]="!editforgotForm.controls.username.errors.pattern" translate>
            email_pattern
          </div>
        </div>
      </div>

      <div class="form-buttons col-12 col-nopad">
        <button pButton type="button" label="Submit" icon="fa fa-check" [disabled]="!editforgotForm.valid" (click)="changePassword($event)"></button>
        <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel" (click)="closeEditForgot($event)"></button>
      </div>
    </form>
  </div>

</div>